import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form, CompaniesAutocomplete } from "@shared/components";

export const StoreListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("v1/company_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <CompaniesAutocomplete
          name="company"
          label={translate("v1/company_admin.fields.company")}
        />
      </Grid>
    </Grid>
  );
});
